module.exports = [
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "choose.json",
		"path": "/choose/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-1-adding-users.json",
		"path": "/wekan/1-adding-users/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-0-adding-new-snap-settings-to-code.json",
		"path": "/wekan/0-adding-new-Snap-settings-to-code/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-4-aws.json",
		"path": "/wekan/4-aws/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-2-apache.json",
		"path": "/wekan/2-apache/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-10-custom-css-themes.json",
		"path": "/wekan/10-custom-css-themes/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "success.json",
		"path": "/success/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-3-archive-and-delete.json",
		"path": "/wekan/3-archive-and-delete/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-5-azure.json",
		"path": "/wekan/5-azure/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-6-backup.json",
		"path": "/wekan/6-backup/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-7-caddy-webserver-config.json",
		"path": "/wekan/7-caddy-webserver-config/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-8-cloud-foundry.json",
		"path": "/wekan/8-cloud-foundry/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-9-cloudron.json",
		"path": "/wekan/9-cloudron/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-elixir-0-introduction.json",
		"path": "/graphql-elixir/0-introduction/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-elixir-1-getting-started.json",
		"path": "/graphql-elixir/1-getting-started/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-elixir-3-mutations.json",
		"path": "/graphql-elixir/3-mutations/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-elixir-4-summary.json",
		"path": "/graphql-elixir/4-summary/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-elixir-2-queries.json",
		"path": "/graphql-elixir/2-queries/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-js-0-introduction.json",
		"path": "/graphql-js/0-introduction/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-js-1-getting-started.json",
		"path": "/graphql-js/1-getting-started/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-js-2-a-simple-query.json",
		"path": "/graphql-js/2-a-simple-query/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-js-4-adding-a-database.json",
		"path": "/graphql-js/4-adding-a-database/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-js-3-a-simple-mutation.json",
		"path": "/graphql-js/3-a-simple-mutation/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-js-5-connecting-server-and-database.json",
		"path": "/graphql-js/5-connecting-server-and-database/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-js-7-subscriptions.json",
		"path": "/graphql-js/7-subscriptions/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-js-6-authentication.json",
		"path": "/graphql-js/6-authentication/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-js-8-filtering-pagination-and-sorting.json",
		"path": "/graphql-js/8-filtering-pagination-and-sorting/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-js-9-summary.json",
		"path": "/graphql-js/9-summary/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-python-0-introduction.json",
		"path": "/graphql-python/0-introduction/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-python-1-getting-started.json",
		"path": "/graphql-python/1-getting-started/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-python-10-summary.json",
		"path": "/graphql-python/10-summary/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-python-3-mutations.json",
		"path": "/graphql-python/3-mutations/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-python-2-queries.json",
		"path": "/graphql-python/2-queries/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-python-4-authentication.json",
		"path": "/graphql-python/4-authentication/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-python-5-links-and-voting.json",
		"path": "/graphql-python/5-links-and-voting/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-python-6-error-handling.json",
		"path": "/graphql-python/6-error-handling/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-python-7-filtering.json",
		"path": "/graphql-python/7-filtering/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-python-8-pagination.json",
		"path": "/graphql-python/8-pagination/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-python-9-relay.json",
		"path": "/graphql-python/9-relay/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-java-0-introduction.json",
		"path": "/graphql-java/0-introduction/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-java-1-getting-started.json",
		"path": "/graphql-java/1-getting-started/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-java-10-pagination.json",
		"path": "/graphql-java/10-pagination/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-java-11-alternative-approaches.json",
		"path": "/graphql-java/11-alternative-approaches/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-java-12-summary.json",
		"path": "/graphql-java/12-summary/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-java-2-queries.json",
		"path": "/graphql-java/2-queries/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-java-3-mutations.json",
		"path": "/graphql-java/3-mutations/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-java-4-connectors.json",
		"path": "/graphql-java/4-connectors/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-java-5-authentication.json",
		"path": "/graphql-java/5-authentication/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-java-6-more-mutations.json",
		"path": "/graphql-java/6-more-mutations/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-java-8-subscriptions.json",
		"path": "/graphql-java/8-subscriptions/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-java-7-error-handling.json",
		"path": "/graphql-java/7-error-handling/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-java-9-filtering.json",
		"path": "/graphql-java/9-filtering/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-ruby-0-introduction.json",
		"path": "/graphql-ruby/0-introduction/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-ruby-1-getting-started.json",
		"path": "/graphql-ruby/1-getting-started/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-ruby-2-queries.json",
		"path": "/graphql-ruby/2-queries/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-ruby-3-mutations.json",
		"path": "/graphql-ruby/3-mutations/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-ruby-4-authentication.json",
		"path": "/graphql-ruby/4-authentication/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-ruby-5-connecting-nodes.json",
		"path": "/graphql-ruby/5-connecting-nodes/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-ruby-6-error-handling.json",
		"path": "/graphql-ruby/6-error-handling/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-ruby-7-filtering.json",
		"path": "/graphql-ruby/7-filtering/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-ruby-8-pagination.json",
		"path": "/graphql-ruby/8-pagination/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-scala-0-introduction.json",
		"path": "/graphql-scala/0-introduction/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-scala-1-getting-started.json",
		"path": "/graphql-scala/1-getting-started/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-ruby-9-summary.json",
		"path": "/graphql-ruby/9-summary/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-scala-2-preparing-first-query.json",
		"path": "/graphql-scala/2-preparing-first-query/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-scala-3-handling-arguments.json",
		"path": "/graphql-scala/3-handling_arguments/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-scala-5-custom-scalars.json",
		"path": "/graphql-scala/5-custom_scalars/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-scala-4-deferred-resolvers.json",
		"path": "/graphql-scala/4-deferred_resolvers/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-scala-6-interfaces.json",
		"path": "/graphql-scala/6-interfaces/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-scala-7-relations.json",
		"path": "/graphql-scala/7-relations/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-scala-8-mutations.json",
		"path": "/graphql-scala/8-mutations/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "graphql-scala-9-authentication.json",
		"path": "/graphql-scala/9-authentication/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-wiki-0-adding-new-snap-settings-to-code.json",
		"path": "/wekan-wiki/0-adding-new-Snap-settings-to-code/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-wiki-1-adding-users.json",
		"path": "/wekan-wiki/1-adding-users/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-wiki-10-custom-css-themes.json",
		"path": "/wekan-wiki/10-custom-css-themes/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-wiki-2-apache.json",
		"path": "/wekan-wiki/2-apache/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-wiki-3-archive-and-delete.json",
		"path": "/wekan-wiki/3-archive-and-delete/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-wiki-4-aws.json",
		"path": "/wekan-wiki/4-aws/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-wiki-5-azure.json",
		"path": "/wekan-wiki/5-azure/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-wiki-6-backup.json",
		"path": "/wekan-wiki/6-backup/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-wiki-7-caddy-webserver-config.json",
		"path": "/wekan-wiki/7-caddy-webserver-config/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-wiki-8-cloud-foundry.json",
		"path": "/wekan-wiki/8-cloud-foundry/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "wekan-wiki-9-cloudron.json",
		"path": "/wekan-wiki/9-cloudron/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "angular-apollo-0-introduction.json",
		"path": "/angular-apollo/0-introduction/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "angular-apollo-1-getting-started.json",
		"path": "/angular-apollo/1-getting-started/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "angular-apollo-10-deploying.json",
		"path": "/angular-apollo/10-deploying/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "angular-apollo-2-queries-loading-links.json",
		"path": "/angular-apollo/2-queries-loading-links/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "angular-apollo-11-summary.json",
		"path": "/angular-apollo/11-summary/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "angular-apollo-3-mutations-creating-links.json",
		"path": "/angular-apollo/3-mutations-creating-links/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "angular-apollo-4-routing.json",
		"path": "/angular-apollo/4-routing/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "angular-apollo-5-authentication.json",
		"path": "/angular-apollo/5-authentication/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "angular-apollo-6-more-mutations-and-updating-the-store.json",
		"path": "/angular-apollo/6-more-mutations-and-updating-the-store/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "angular-apollo-7-filtering-searching-the-list-of-links.json",
		"path": "/angular-apollo/7-filtering-searching-the-list-of-links/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "angular-apollo-8-subscriptions.json",
		"path": "/angular-apollo/8-subscriptions/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-apollo-0-introduction.json",
		"path": "/react-apollo/0-introduction/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "angular-apollo-9-pagination.json",
		"path": "/angular-apollo/9-pagination/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-apollo-1-getting-started.json",
		"path": "/react-apollo/1-getting-started/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-apollo-10-summary.json",
		"path": "/react-apollo/10-summary/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-apollo-3-mutations-creating-links.json",
		"path": "/react-apollo/3-mutations-creating-links/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-apollo-2-queries-loading-links.json",
		"path": "/react-apollo/2-queries-loading-links/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-apollo-4-routing.json",
		"path": "/react-apollo/4-routing/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-apollo-5-authentication.json",
		"path": "/react-apollo/5-authentication/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-apollo-6-more-mutations-and-updating-the-store.json",
		"path": "/react-apollo/6-more-mutations-and-updating-the-store/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-apollo-7-filtering-searching-the-list-of-links.json",
		"path": "/react-apollo/7-filtering-searching-the-list-of-links/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-apollo-8-subscriptions.json",
		"path": "/react-apollo/8-subscriptions/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-apollo-9-pagination.json",
		"path": "/react-apollo/9-pagination/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-relay-0-introduction.json",
		"path": "/react-relay/0-introduction/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-relay-1-getting-started.json",
		"path": "/react-relay/1-getting-started/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-relay-2-queries-loading-links.json",
		"path": "/react-relay/2-queries-loading-links/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-relay-3-mutations-creating-links.json",
		"path": "/react-relay/3-mutations-creating-links/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-relay-4-routing.json",
		"path": "/react-relay/4-routing/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-relay-5-authentication.json",
		"path": "/react-relay/5-authentication/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-relay-7-subscriptions.json",
		"path": "/react-relay/7-subscriptions/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-relay-6-more-mutations-and-updating-the-store.json",
		"path": "/react-relay/6-more-mutations-and-updating-the-store/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-relay-8-pagination.json",
		"path": "/react-relay/8-pagination/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "react-relay-9-summary.json",
		"path": "/react-relay/9-summary/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "advanced-0-clients.json",
		"path": "/advanced/0-clients/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "advanced-2-more-graphql-concepts.json",
		"path": "/advanced/2-more-graphql-concepts/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "advanced-1-server.json",
		"path": "/advanced/1-server/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "advanced-3-tooling-and-ecosystem.json",
		"path": "/advanced/3-tooling-and-ecosystem/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "advanced-4-security.json",
		"path": "/advanced/4-security/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "advanced-5-common-questions.json",
		"path": "/advanced/5-common-questions/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-apollo-0-introduction.json",
		"path": "/vue-apollo/0-introduction/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-apollo-2-queries-loading-links.json",
		"path": "/vue-apollo/2-queries-loading-links/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-apollo-11-summary.json",
		"path": "/vue-apollo/11-summary/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-apollo-3-mutations-creating-links.json",
		"path": "/vue-apollo/3-mutations-creating-links/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-apollo-4-routing.json",
		"path": "/vue-apollo/4-routing/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-apollo-1-getting-started.json",
		"path": "/vue-apollo/1-getting-started/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-apollo-10-deploying.json",
		"path": "/vue-apollo/10-deploying/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-apollo-5-authentication.json",
		"path": "/vue-apollo/5-authentication/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-apollo-6-more-mutations-and-updating-the-store.json",
		"path": "/vue-apollo/6-more-mutations-and-updating-the-store/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-apollo-7-filtering-searching-the-list-of-links.json",
		"path": "/vue-apollo/7-filtering-searching-the-list-of-links/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-apollo-8-subscriptions.json",
		"path": "/vue-apollo/8-subscriptions/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "basics-0-introduction.json",
		"path": "/basics/0-introduction/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "basics-1-graphql-is-the-better-rest.json",
		"path": "/basics/1-graphql-is-the-better-rest/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "basics-2-core-concepts.json",
		"path": "/basics/2-core-concepts/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "ember-apollo-0-introduction.json",
		"path": "/ember-apollo/0-introduction/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "basics-3-big-picture.json",
		"path": "/basics/3-big-picture/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "ember-apollo-1-getting-started.json",
		"path": "/ember-apollo/1-getting-started/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "ember-apollo-2-queries-loading-links.json",
		"path": "/ember-apollo/2-queries-loading-links/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "ember-apollo-4-navigation.json",
		"path": "/ember-apollo/4-navigation/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "ember-apollo-3-mutations-creating-links.json",
		"path": "/ember-apollo/3-mutations-creating-links/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "ember-apollo-6-more-mutations-and-updating-the-store.json",
		"path": "/ember-apollo/6-more-mutations-and-updating-the-store/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "ember-apollo-7-filtering-searching-the-list-of-links.json",
		"path": "/ember-apollo/7-filtering-searching-the-list-of-links/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "ember-apollo-8-summary.json",
		"path": "/ember-apollo/8-summary/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-apollo-9-pagination.json",
		"path": "/vue-apollo/9-pagination/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "ember-apollo-5-authentication.json",
		"path": "/ember-apollo/5-authentication/"
	},
	{
		"componentChunkName": "page-component---src-pages-404-tsx",
		"jsonName": "404.json",
		"path": "/404/"
	},
	{
		"componentChunkName": "page-component---src-pages-index-tsx",
		"jsonName": "index.json",
		"path": "/"
	},
	{
		"componentChunkName": "page-component---src-pages-404-tsx",
		"jsonName": "404-html.json",
		"path": "/404.html"
	}
];


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = ./.cache/pages.json
// module chunks = 154